import React from 'react';

export default function Download({
	href,
	filename,
	children,
}: {
	href: string | undefined;
	filename: string;
	children: React.ReactNode;
}) {
	return (
		<a download={filename} href={href}>
			{children}
		</a>
	);
}
